import { useMutation } from '@tanstack/react-query'
import * as React from 'react'
import { Alert } from '@/components/ui/alert'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { postJSON } from '@/lib/api'

interface MarketingOptOutResponse {
  marketing_opt_out: { email_address: string; headline: string; detail: string }
}

export function MarketingOptOutPage({ token }: { token: string }) {
  const optOut = useMutation({
    mutationFn: () => postJSON<MarketingOptOutResponse>(`/api/v1/marketing_opt_outs/${token}`, {}),
  })

  React.useEffect(() => {
    optOut.mutate()
  }, [token]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <main className="min-h-screen bg-background">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-6 sm:px-8">
        <div className="max-w-xl">
          {optOut.isPending || optOut.isIdle ? (
            <p className="text-body-sm text-muted-foreground" role="status">
              Recording your preference...
            </p>
          ) : optOut.isError ? (
            <Alert>Unsubscribe link unavailable</Alert>
          ) : (
            <Card>
              <CardHeader className="p-4 pb-0">
                <CardTitle className="text-heading-sm">
                  {optOut.data.marketing_opt_out.headline}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2 p-4 text-body-sm">
                <p className="text-foreground">{optOut.data.marketing_opt_out.email_address}</p>
                <p className="text-muted-foreground">{optOut.data.marketing_opt_out.detail}</p>
              </CardContent>
            </Card>
          )}
        </div>
      </div>
    </main>
  )
}
